function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 12
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6 11h12a1 1 0 110 2H6a1 1 0 110-2z",
  fill: "#fff"
});

function SvgRemoveCountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iMTIiLz4KPHBhdGggZD0iTTYgMTFIMThDMTguNTUyMyAxMSAxOSAxMS40NDc3IDE5IDEyQzE5IDEyLjU1MjMgMTguNTUyMyAxMyAxOCAxM0g2QzUuNDQ3NzIgMTMgNSAxMi41NTIzIDUgMTJDNSAxMS40NDc3IDUuNDQ3NzIgMTEgNiAxMVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgRemoveCountIcon as ReactComponent };